import React from 'react'

import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'

import useAuthTraining from 'hooks/useAuthTraining'
import * as service from 'service'

const DefaultComponent = ({ children }) => <>{children}</>

const TrainingRouteWithLayout = ({
  auth,
  layout,
  component: Component,
  ...rest
}) => {
  const Layout = layout || DefaultComponent
  const isAuthenticated = service.trainingPortal.auth.isAuthenticated()
  const { portalToken } = useAuthTraining()

  if (isAuthenticated) {
    if (!auth) {
      service.history.push(`/training/${portalToken}/home`)
      return null
    }
  } else {
    if (auth) {
      service.trainingPortal.auth.logout()
      return null
    }
  }

  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <Layout>
          <Component {...matchProps} />
        </Layout>
      )}
    />
  )
}

TrainingRouteWithLayout.propTypes = {
  auth: PropTypes.bool,
  component: PropTypes.any,
  layout: PropTypes.any,
  path: PropTypes.string,
}

export default TrainingRouteWithLayout
